import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import {configureStore} from "@reduxjs/toolkit"
import { Provider } from 'react-redux';
import rootReducer from "./components/reducers/rootReducer"
import { ToastContainer } from 'react-toastify';



const store = configureStore({
  reducer:rootReducer,
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
    <App />
    <ToastContainer
    position="top-right"
        />
    </BrowserRouter>
    </Provider>
);
